<template>
	<v-app>
		<v-main>
			<v-container class="px-0" v-if="showApp">
                <router-view id="router-view"/>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { firebase, tracker } from "./main";
import axios from "axios";

export default {
	computed: {
		showApp() {
			if(!this.$store.state.inapp.isApp) {
				return true;
			}
			return this.$store.state.inapp.inited;
		}
	},
    mounted() {
		if(typeof navigator.onLine == "boolean") {
			this.$store.state.online = navigator.onLine;
		}

		loginNew.onCookieStateChanged(() => {
			tracker.configure();
		});
		loginNew.onAuthStateChanged((event) => {
			if (loginNew.isSignedIn()) {
				this.$store.commit("signInLoginNew", true);
				if (firebase.auth().currentUser == null || firebase.auth().currentUser.uid != loginNew.getProfile().sub) {
					axios.get(process.env.VUE_APP_API_URL + "api/getIdToken?id=" +loginNew.getIdToken()).then((response) => {
						if (response.data.error == "none") {
							firebase.auth().signInWithCustomToken(response.data.id_token).catch((error) => {});
						}
					}).catch((error) => {});
				}
			} else {
				this.$store.commit("signInLoginNew", false);
			}
		});
		loginNew.onNEWApp(() => {
			this.$store.commit("setNEWAppProperties");
			if(!loginNew.isSignedIn()) {
				loginNew.auth();
			}
		});
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				this.$store.commit("signInFirebase", true);
			} else {
				this.$store.commit("signInFirebase", false);
			}
		});
	}
}
</script>
<style lang="scss">
.container {
	max-width: 500px!important;
}
body{
    overflow-x: hidden;
}
h3 {
    font-size: 1.7em;
    font-weight: normal;
}
</style>